
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";

import { Heading } from "@/components/Heading";
import { Image } from "@/components/Image";
import { Grid } from "@/components/Grid";
import { BlogText } from "@/components/BlogText";
import { CTASection } from "@/sections/CTASection";
import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";

const OpenXdInUXPin = () => {
  const { colors } = useTheme();
  return (
    <>
      <Head
        pageNamespace="page/open-xd-in-uxpin"
        ogImage="/images/main-og-image.jpg"
      />

      <div>
        <Grid
          customStyle={{
            maxWidth: 800,
            flexDirection: "column",
            alignItems: "flex-start",
            paddingBottom: "0 !important",
          }}
        >
          <Heading as="h1">Import XD files in UXPin</Heading>
          <BlogText>
            Currently, it is not possible to open Adobe XD files in UXPin, but
            we have a simple and effective way to do this using our converter.
          </BlogText>
          <BlogText>
            Firstly we need to convert the XD file into a format that UXPin will
            accept. We can do this&nbsp;
            <a
              href="/"
              style={{
                color: colors.RED,
                fontWeight: "bold",
              }}
            >
              using our XD to Sketch converter
            </a>
            &nbsp; and then import the files into UXPin directly.
          </BlogText>
          <BlogText>Let’s get started</BlogText>

          <section>
            <Heading as="h3">Convert your XD file to Sketch</Heading>
            <ol>
              <li>
                <BlogText>
                  <strong>Upload your file to Magicul</strong>
                  &nbsp;-&nbsp;go to &nbsp;
                  <a
                    href="/"
                    style={{
                      color: colors.RED,
                      fontWeight: "bold",
                    }}
                  >
                    XD to Sketch converter
                  </a>
                  &nbsp; and drag a file to the converter or click on browse to
                  upload your file.
                </BlogText>
                <Image
                  customStyle={{ width: "100%", marginBottom: 29 }}
                  src="/images/tutorials/uploading-image.jpg"
                  alt="Magicul uploading dialog"
                />
              </li>
              <li>
                <BlogText>
                  <strong>Select your plan</strong>
                  &nbsp;- Click on convert now and select your plan.
                </BlogText>
              </li>
              <li>
                <BlogText>
                  <strong>Complete the checkout</strong>
                  &nbsp;-&nbsp;enter your details and complete the checkout.
                  Your file will now convert from the XD to Sketch/Figma.
                </BlogText>
              </li>
              <li>
                <BlogText>
                  <strong>Download your file</strong>
                  &nbsp;-&nbsp;click the arrow button to download the converted
                  file.
                </BlogText>
                <Image
                  customStyle={{ width: "100%", marginBottom: 29 }}
                  src="/images/tutorials/downloading-image.jpg"
                  alt="Magicul downloading dialog"
                />
              </li>
            </ol>
            <BlogText>
              Now we have a Sketch file that can be imported into UXPin.
            </BlogText>
          </section>
          <section>
            <Heading as="h3">Importing into UXPin</Heading>
            <ol>
              <li>
                <BlogText>Open a new or existing project in UXPin.</BlogText>
              </li>
              <li>
                <BlogText>
                  Drag and drop the Sketch file into the project OR click the
                  Import Sketch button3).
                </BlogText>
                <Image
                  customStyle={{ width: "100%", marginBottom: 29 }}
                  src="/images/tutorials/open-xd-in-uxpin/start-uxpin.jpg"
                  alt="start uxpin"
                />
              </li>
              <li>
                <BlogText>The file will now upload and convert.</BlogText>
                <Image
                  customStyle={{ width: "100%", marginBottom: 29 }}
                  src="/images/tutorials/open-xd-in-uxpin/upload-progress.jpg"
                  alt="upload progress"
                />
              </li>
              <li>
                <BlogText>
                  You can now edit or preview your design in UXPin
                </BlogText>
                <Image
                  customStyle={{ width: "100%", marginBottom: 29 }}
                  src="/images/tutorials/open-xd-in-uxpin/edit-preview-dialog.jpg"
                  alt="edit preview dialog"
                />
              </li>
            </ol>
            <BlogText>It is as simple as that, happy prototyping!</BlogText>
            <CTASection
              title="Want to convert XD files to UXPin?"
              buttonLabel="Start Now"
              href="/"
            />
          </section>
        </Grid>
      </div>
    </>
  );
};

export default OpenXdInUXPin;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/tutorials/open-xd-in-uxpin',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  